// extracted by mini-css-extract-plugin
export var header = "HomePage-module--header--YmVO5";
export var name = "HomePage-module--name--e1I4a";
export var intro = "HomePage-module--intro--sthqJ";
export var social = "HomePage-module--social--Rt+gd";
export var recent = "HomePage-module--recent--3IWBM";
export var recentSection = "HomePage-module--recentSection--tTD6K";
export var iconExternal = "HomePage-module--iconExternal--qSLM9";
export var seeMore = "HomePage-module--seeMore--eq5aJ";